import { render, staticRenderFns } from "./MentorMentorships.vue?vue&type=template&id=9e876cbc&"
import script from "./MentorMentorships.vue?vue&type=script&lang=js&"
export * from "./MentorMentorships.vue?vue&type=script&lang=js&"
import style0 from "./MentorMentorships.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports